import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { PressArticle } from '../types/content';

/** Articles de presse actifs, triés par display_order puis date de publication. */
export function usePressArticles() {
  const [articles, setArticles] = useState<PressArticle[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (!supabase) {
        setLoading(false);
        return;
      }
      const { data } = await supabase
        .from('press_articles')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true })
        .order('published_at', { ascending: false });
      setArticles((data as PressArticle[]) || []);
      setLoading(false);
    })();
  }, []);

  return { articles, loading };
}

export default usePressArticles;
